// extracted by mini-css-extract-plugin
export default {"main-textarea":"TextArea_main-textarea__DbL6C","read-only":"TextArea_read-only__UHp0p"};